// src/app/guards/auth.guard.ts
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';
import { AuthStateService } from '../services/auth-state.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private router: Router, private tokenStorage: TokenStorageService, private authState: AuthStateService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Prefer reactive state (cross-tab updates), fallback to current token
    const token = this.tokenStorage.getToken();
    if (token) {
      if (this.tokenStorage.isExpired()) {
        this.tokenStorage.signOut();
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }
      // refresh activity on navigation
      this.tokenStorage.updateActivity();
      return true;
    }

    return this.authState.isAuthenticated$.pipe(
      take(1),
      map((isAuth) => {
        if (isAuth || this.tokenStorage.getToken()) {
          return true;
        }
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      })
    );
  }
}
